// extracted by mini-css-extract-plugin
export default {"menu":"QeXY8O","catalog":"daf1PX","other":"FsC551"};